import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './styles/index.css'
import './styles/tailwind.css'

import { loadConfig } from './config/runtime'

async function boot() {
  await loadConfig() // stores read page sizes at creation
  const [{ App }] = await Promise.all([import('./App')])
  const root = document.getElementById('root')
  if (!root) throw new Error('#root is missing')
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void boot()
